import { useState, useEffect } from 'react';

const TotalFooter = ({ data, field }) => {

  const total = data.reduce((accumulator, row) => accumulator + (row[field] || 0), 0);
  return (<div>Total: {total.toFixed(2)}</div>);
};

export { TotalFooter };
